import { logUsage } from 'owa-analytics';
import { trace } from 'owa-trace';

// Regex to match GUID
const GUID_REGEX = new RegExp('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}', 'i');

/**
 * src could potentially contain file name which is PII so we should scrub it before logging
 * The way it scrub the src is to keep the protocol section, and log either <GUID> if it matches or
 * <PII> if not
 */
function getScrubbedSrc(src: string) {
    if (!src) {
        return '';
    }

    let protocol = '';
    let reminder = src;
    const colonIndex = src.indexOf(':');
    if (colonIndex >= 0) {
        protocol = src.slice(0, colonIndex + 1);
        reminder = src.slice(colonIndex + 1);
    }

    reminder = reminder.match(GUID_REGEX) ? '<GUID>' : '<PII>';
    return protocol + reminder;
}

/**
 * Log image load error
 * @param type The type
 * @param howLoad how image is loaded (crossdomain, proxy etc.)
 * @param error The error
 * @param statusCode The status code (i.e. 401)
 * @param context The context
 * @param loaderCode The loader code
 * @param originalSrc The original src
 * @param contentType The content type
 * @param field1 extra field1
 * @param field2 extra field2
 * @param field3 extra field3
 * @param field4 extra field4
 * @param field5 extra field5
 * @param field6 extra field6
 * */
export default function logImageLoadError(
    type: string,
    howLoad: string,
    error: string,
    statusCode: string = '',
    context: string = '',
    loaderCode: string = '',
    originalSrc: string = '',
    contentType: string = '',
    field1: string = '',
    field2: string = '',
    field3: string = '',
    field4: string = '',
    field5: string = '',
    field6: string = ''
) {
    // Log the datapoint
    originalSrc = getScrubbedSrc(originalSrc);
    const cd = [
        type,
        howLoad,
        error,
        statusCode,
        context,
        loaderCode,
        originalSrc,
        contentType,
        field1,
        field2,
        field3,
        field4,
        field5,
        field6,
    ];
    const eventName = 'InlineImageLoadError';
    logUsage(eventName, cd);
    trace.info(`${eventName}: ${cd}`);
}
